/**
 * Prod origin of the freebuff.com web app (marketing site + browser sign-in).
 * The CLI and Freebuff Desktop both send users here for the device-code login
 * flow; sharing the literal keeps their prod defaults from drifting.
 */
export const FREEBUFF_WEB_URL_PROD = 'https://freebuff.com'
